const url = (urlTemplate: string, sellerId: number|string|undefined): string => {

    let url = urlTemplate;

    if (sellerId) {
        sellerId = sellerId.toString()
        return url.replace('/:id', `/${sellerId}`).replace(':sellerId', sellerId);
    }

    return url;
}

export default url;